<template>
  <div class="cabinet-login-box-container">
    <!--    <LabelledInput label="email" type="email"></LabelledInput>-->
    <!--    <LabelledInput label="password" type="password"></LabelledInput>-->

    <div class="form__group field">
      <input type="email" id="labelled-field-email" name="labelled-field-email" class="form__field form__email"
             :placeholder="$t('loginBoxEmail')" v-model="email">
      <label for="labelled-field-email" class="form__label">{{ $t('loginBox.email') }}</label>
    </div>

    <div class="form__group field">
      <input type="password" id="labelled-field-password" name="labelled-field-password" class="form__field form__email"
             :placeholder="$t('loginBoxPassword')" v-model="password">
      <label for="labelled-field-password" class="form__label">{{ $t('loginBox.password') }}</label>
    </div>

    <button class="submit red-button" @click="submit" :disabled="buttonsAreDisabled">{{ $t('loginBox.submit') }}</button>
    <button class="forgot" @click="forgot" :disabled="buttonsAreDisabled">{{ $t('loginBox.forgot') }}</button>
  </div>
</template>

<script>
// import LabelledInput from "@/components/LabelledInput";

import {ref} from "@vue/runtime-core"

export default {
  name: "LoginBox",
  props: {
    'auto': Boolean
  },
  emits: ['submit', 'forgot'],
  setup (props, { emit }) {
    let email = ref(null)
    let password = ref(null)
    let buttonsAreDisabled = ref(false)

    const lock = (() => {
      buttonsAreDisabled.value = true
    })

    const release = (() => {
      buttonsAreDisabled.value = false
    })

    const clear = (() => {
      email.value = null
      password.value = null
    })

    const submit = (() => {
      if (props.auto != null && props.auto)
        buttonsAreDisabled.value = true
      emit('submit', email.value, password.value)
    })

    const forgot = (() => {
      if (props.auto != null && props.auto)
        buttonsAreDisabled.value = true
      emit('forgot', email.value)
    })

    return {
      lock: lock,
      release: release,
      clear: clear,
      submit: submit,
      forgot: forgot,
      email: email,
      password: password,
      buttonsAreDisabled: buttonsAreDisabled
    }
  }
}
</script>
